import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useCallback, useEffect, useState } from "react";

import type { FC, PropsWithChildren } from "react";

export const HoldingDialog: FC<
  PropsWithChildren<{
    pageReady: boolean;
    dialogTitle: string;
    continueButtonText: string;
    onDismiss?: () => void;
  }>
> = ({ pageReady, dialogTitle, continueButtonText, children, onDismiss }) => {
  const [modalDismissed, setModalDismissed] = useState(false);
  const [timerExpired, setTimerExpired] = useState(false);
  const modalMinimumMs = 5000;

  const handleClose = useCallback((): void => {
    setModalDismissed(true);
    onDismiss?.();
  }, [onDismiss]);

  useEffect(() => {
    const modalOpenTimer = setTimeout(() => {
      setTimerExpired(true);
    }, modalMinimumMs);

    return () => clearTimeout(modalOpenTimer);
  }, []);

  useEffect(() => {
    if (pageReady && timerExpired) {
      onDismiss?.();
    }
  }, [pageReady, timerExpired, onDismiss]);

  return (
    <Dialog open={!modalDismissed && !(pageReady && timerExpired)}>
      <DialogTitle>{dialogTitle}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button onClick={handleClose} variant="text" data-analytics-id="mfai-modal-continue">
          {continueButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
